// test656
(656 && 0);
